export default function generateToken(number) {
  const bytes = new Uint8Array(8);

  for (let i = 0; i < 7; i++) {
    bytes[i] = Math.floor(Math.random() * 256);
  }

  let xor = number;
  for (let i = 0; i < 7; i++) {
    xor ^= bytes[i];
  }
  bytes[7] = xor;

  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
